import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import LocationResult from 'src/components/locationresultlist/LocationResult';
import styles from './LocationResultList.module.css';
import { locale } from "@locale";

//#region [Props]
type LocationResultListProps = {
  locationList?: string[];
  maxNumToShow?: number;
  className?: string;
  clickTracker: (locationName: string) => void;
  forceHardlinks?: boolean;
};
//#endregion

//#region [Component]
export default function LocationResultList(t0) {
  const $ = _c(12);
  const {
    locationList,
    maxNumToShow: t1,
    className,
    clickTracker,
    forceHardlinks: t2
  } = t0;
  const maxNumToShow = t1 === undefined ? 6 : t1;
  t2 === undefined ? false : t2;
  if ((locationList?.length ?? 0) === 0) {
    return null;
  }
  let t3;
  if ($[0] !== className) {
    t3 = classNames(styles.SLocationResultList, className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className={styles.SH1}>{locale.search.locationResultHeading}</h2>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== clickTracker || $[4] !== locationList || $[5] !== maxNumToShow) {
    let t6;
    if ($[7] !== clickTracker) {
      t6 = locationName => <LocationResult className={styles.SLocationItem} locationName={locationName} key={locationName} onClick={() => clickTracker(locationName)} />;
      $[7] = clickTracker;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    t5 = locationList.slice(0, maxNumToShow).map(t6);
    $[3] = clickTracker;
    $[4] = locationList;
    $[5] = maxNumToShow;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <section className={t3}>{t4}{t5}</section>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
//#endregion